export default {"src":"/_next/static/media/logo.d36781e5.svg","height":263,"width":1015};